import { render, staticRenderFns } from "./form-table-submitted-preview.vue?vue&type=template&id=5751e014&scoped=true&"
import script from "./form-table-submitted-preview.vue?vue&type=script&lang=js&"
export * from "./form-table-submitted-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-table-submitted-preview.vue?vue&type=style&index=0&id=5751e014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5751e014",
  null
  
)

component.options.__file = "form-table-submitted-preview.vue"
export default component.exports